export const import_invoice_lang = {
  TH: {
    header_card: "นำเข้าข้อมูลใบแจ้งหนี้",
    bill_id: "รหัสใบเสร็จรับเงิน",
    user_id: "ผู้ออกเอกสาร",
    create_datetime: "วันที่สร้าง",
    status_code: "สถานะการชำระ",
    payment_id: "รหัสประเภทการชำระ",
    flag: "สถานะการใช้งาน",
    due_date: "กำหนดชำระเงิน",
    discount: "ส่วนลด",
    remark: "หมายเหตุ",
    total_price: "ยอดที่ชำระ",
    import_excel: "เลือกไฟล์ที่จะ Import",
    download_excel: "Download ไฟล์ Template",
    save: "บันทึกข้อมูล",
    clear: "ล้างข้อมูล",
    approve_detail: "คุณต้องการนำเข้าข้อมูลทั้งหมดนี้ใช่ไหม ?",
    approve_title: "กรุณายืนยัน",
    confirm: "ยืนยัน",
    cancel: "ยกเลิก",
    inform_title: "ไม่สามารถดำเนินการนำเข้า",
    inform_titlee: "ไม่สามารถปรับปรุงใบแจ้งหนี้ได้",

    inform_detail: "กรุณาเลือกไฟล์ Excel ก่อนบันทึกข้อมูล",
    inform_detaill: "กรุณาตรวจสอบไฟล์ Excel ก่อนบันทึกข้อมูล",
    pay: 'วันที่รับเงิน',
    pay_not: 'จำนวนเงิน',
    invoice_id: "รหัสใบแจ้งหนี้",
    fee_id: "รหัสค่าธรรมเนียม",
    fee_price: "ค่าธรรมเนียม",
    vat: "ภาษี",
    vat_rate: "เรทภาษี",
    print_count: "จำนวนครั้งที่พิมพ์",
    user_name: "ชื่อผู้เสียค่าธรรมเนียม",
    fee_type:'ประเภทค่าธรรมเนียม'
  },

  EN: {
    fee_type:'fee type',
    pay: 'pay date',
    pay_not: 'total price',
    header_card: "Import Invoice",
    bill_id: "Bill Id",
    user_id: "User Make",
    create_datetime: "Create Date",
    status_code: "Status Payment",
    payment_id: "Payment type",
    flag: "Status",
    due_date: "Due Date",
    discount: "Discount",
    remark: "Remark",
    inform_detaill :"Unable to update receipt",
    inform_titlee:"Please check Excel file before saving data.",
    total_price: "Total Price",
    import_excel: "Select file for Import",
    download_excel: "Download Template file",
    save: "Save",
    clear: "Clear",
    approve_detail: "You need import this information right?",
    approve_title: "Please Confirm",
    confirm: "Confirm",
    cancel: "Cancel",
    invoice_id: "Invoice Id",
    fee_id: "Fee Id",
    fee_price: "Fee Price",
    vat: "Vat",
    vat_rate: "Vat Rate",
    print_count: "Print Count",
    user_name: "Fullname"

  }
}
